"use strict";

function validateMonth(value) {
    if (!value) {
        return;
    }

    var parts = value.split('/');

    if (parts.length < 2) return true;

    if (parts[0].length < 2) return;

    return parseInt(parts[0], 10) <= 12;
}

export const settings = {
    options: {
        message: "The input month is invalid"
    }
};

export default function validMonth(options) {
    const opts = options ? {...settings.options, options} : settings.options;

    return function validMonth$return(val) {
        if (val && !validateMonth(val)) {
            return {
                message: opts.message,
                level: opts.level,
                type: opts.type
            };
        }
    }
};


/** WEBPACK FOOTER **
 ** ./src/validators/validMonth.js
 **/